import {AfterViewChecked, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import {GenericListDialogComponent} from '../../../../common/dialogs/generic-list-dialog/generic-list-dialog.component';
import {NameValueDTO} from '../../../../common/models/NameValueDTO';
import {HelpDTO} from '../../../../other/models/HelpDTO';
import {
  DrugManagementPlanDTO,
  GrandfatherManPlanLinkDTO,
  NationalDrugFormularyManPlanLinkDTO,
  PrescriptionLimitDTO,
  RefillManPlanLinkDTO,
  StepTherapyManPlanLinkDTO,
  TherapeuticDuplicationDTO
} from '../../../models/DrugManagementPlanDTO';
import {MatStepper} from '@angular/material/stepper';
import {ActivatedRoute, Router} from '@angular/router';
import {KeycloakService} from 'keycloak-angular';
import {LookupService} from '../../../../common/services/lookup.service';
import {HelpService} from '../../../../other/services/help.service';
import {DrugManagementPlanService} from '../../../services/drug-management-plan.service';
import {NationalDrugFormularyService} from '../../../services/national-drug-formulary.service';
import {PagedRequestDTO} from '../../../../common/models/PagedRequestDTO';
import {RefillService} from '../../../services/refill.service';
import {RefillDTO} from '../../../models/RefillDTO';
import {debounceTime} from 'rxjs/operators';
import {Observable, Subject, Subscription, throwError} from 'rxjs';
import {AddRefillDialogComponent} from '../../dialogs/add-refill-dialog/add-refill-dialog.component';
import {ConfirmationDialogComponent} from '../../../../common/dialogs/confirmation-dialog/confirmation-dialog.component';
import {DatePipe} from '@angular/common';
import {NationalDrugFormularyDTO} from '../../../models/NationalDrugFormularyDTO';
import {GrandfatherService} from '../../../services/grandfather.service';
import {GrandfatherDTO} from '../../../models/GrandfatherDTO';
import {AddGrandfatherDialogComponent} from '../../dialogs/add-grandfather-dialog/add-grandfather-dialog.component';
import {BaseDTO} from '../../../../common/models/BaseDTO';
import {NameDateDTO} from '../../../../common/models/NameDateDTO';
import {DateUtil} from 'src/app/modules/common/util/DateUtil';
import {Common, createFieldMap} from '../../../../common/util/Util';
import {SharedService} from '../../../../common/services/shared-service';
import {EntityTable} from '../../../../common/types/entity-table.enum';
import {LookupValue} from '../../../../clm/types/lookup-value.enum';

enum PrescriptionLimitType {
  daysDuringpolicy = 1,
  daysPostPolicy = 2
}

const ALERT_MESSAGE = 'Ensure that all required fields are completed correctly';

@Component({
  selector: 'app-add-drug-management-plan-view',
  templateUrl: './add-drug-management-plan-view.component.html',
  styleUrls: ['./add-drug-management-plan-view.component.scss', '../../../../../../styles/global/_add-view-edit-styles.scss']
})
export class AddDrugManagementPlanViewComponent implements OnInit, AfterViewChecked, OnDestroy {
  readonly debounceTime = Common.DEBOUNCE_TIME;
  readonly lookupValue = LookupValue;
  readonly defaultEndDateValue = '2999-12-31'; // This date is used to represent default endDate for open dated(empty) End Date field.

  drugManagementPlanNameFormControl: FormControl;
  drugManagementPlanStartDateFormControl: FormControl;
  drugManagementPlanEndDateFormControl: FormControl;
  drugManagementPlanPolicyFormControl: FormControl;
  drugManagementPlanProductFormControl: FormControl;

  refillNameFormControl: FormControl;
  refillStartDateFormControl: FormControl;
  refillEndDateFormControl: FormControl;

  prescriptionDuringValueFormControl: FormControl;
  prescriptionAfterValueFormControl: FormControl;
  prescriptionStartDateFormControl: FormControl;
  prescriptionEndDateFormControl: FormControl;

  applyTherapeuticDuplicationFormControl: FormControl;
  applyLevelFourFormControl: FormControl;
  applyLevelFourDosageFormControl: FormControl;
  applyLevelFourDosageIndicatorFormControl: FormControl;
  applyLevelFiveFormControl: FormControl;
  applyLevelFiveDosageFormControl: FormControl;
  applyLevelFiveDosageIndicatorFormControl: FormControl;
  therapeuticStartDateFormControl: FormControl;
  therapeuticEndDateFormControl: FormControl;

  // applyStepTherapyFormControl: FormControl;
  stepTherapyFormControl: FormControl;
  stepTherapyStartDateFormControl: FormControl;
  stepTherapyEndDateFormControl: FormControl;

  formularyFormControl: FormControl;
  formularyStartDateFormControl: FormControl;
  formularyEndDateFormControl: FormControl;

  grandfatherNameFormControl: FormControl;
  grandfatherStartDateFormControl: FormControl;
  grandfatherEndDateFormControl: FormControl;

  generalFormGroup: FormGroup;
  refillParametersFormGroup: FormGroup;
  prescriptionLimitsFormGroup: FormGroup;
  therapeuticDuplicationsFormGroup: FormGroup;
  stepTherapiesFormGroup: FormGroup;
  formulariesFormGroup: FormGroup;
  grandfatherFormGroup: FormGroup;

  policies: NameValueDTO[];
  products: NameValueDTO[];
  prescriptionLimitTypes: NameValueDTO[];
  displayedStepTherapies: NameValueDTO[];
  removedStepTherapies: NameValueDTO[];
  helpInfo: HelpDTO[];
  dateFormat = DateUtil.dateFormat;
  userFirstLastName = '';

  editDrugManagementPlan = new DrugManagementPlanDTO();
  isEdit = false;
  isSaving = false;
  planApplications: string[] = ['Policy', 'Product'];
  chosenPlanApplication = 'Product';
  editOptions: string[] = ['Current', 'New'];
  generalStartDate: Date;
  generalEndDate: Date;
  addTooltip = 'Click to create a new one';
  editTooltip = 'Click to edit the current selection';
  deleteTooltip = 'Click to delete the current selection';

  dmpRefills: RefillManPlanLinkDTO[] = [];
  chosenRefillOption = 'New';
  addRefillText = 'Add';
  selectedRefill: RefillDTO;
  filteredRefills: RefillDTO[];
  refillNameTextChanged = new Subject<string>();
  refillNameSubscription: Subscription;

  dmpPrescriptions: PrescriptionLimitDTO[] = [];
  chosenPrescriptionOption = 'New';

  dmpTherapeuticDuplications: TherapeuticDuplicationDTO[] = [];
  chosenTherapeuticOption = 'New';

  dmpStepTherapies: StepTherapyManPlanLinkDTO[] = [];
  chosenStepTherapyOption = 'New';

  dmpFormularies: NationalDrugFormularyManPlanLinkDTO[] = [];
  chosenFormularyOption = 'New';
  filteredFormularies: NationalDrugFormularyDTO[];
  formularyTextChanged = new Subject<string>();
  formularyNameSubscription: Subscription;
  dmpGrandfathers: GrandfatherManPlanLinkDTO[] = [];
  chosenGrandfatherOption = 'New';
  addGrandfatherText = 'Add';
  selectedGrandfather: GrandfatherDTO;
  filteredGrandfathers: GrandfatherDTO[];
  grandfatherNameTextChanged = new Subject<string>();
  grandfatherNameSubscription: Subscription;
  @ViewChild('stepper') private drugManagementPlanStepper: MatStepper;
  // @ViewChild('formularyStartDateElement') private formularyStartDateElement: ElementRef;
  // @ViewChild('formularyNameElement') private formularyNameElement: MatSelect;

  constructor(
    private changeDetect: ChangeDetectorRef,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    public datePipe: DatePipe,
    private keycloakService: KeycloakService,
    private lookupService: LookupService,
    private sharedService: SharedService,
    private drugManagementPlanService: DrugManagementPlanService,
    private nationalDrugFormularyService: NationalDrugFormularyService,
    private refillService: RefillService,
    private grandfatherService: GrandfatherService,
    private helpService: HelpService
  ) {
    this.drugManagementPlanNameFormControl = new FormControl('');
    this.drugManagementPlanStartDateFormControl = new FormControl('');
    this.drugManagementPlanEndDateFormControl = new FormControl('');
    this.drugManagementPlanPolicyFormControl = new FormControl('');
    this.drugManagementPlanProductFormControl = new FormControl('');

    this.refillNameFormControl = new FormControl('');
    this.refillStartDateFormControl = new FormControl('');
    this.refillEndDateFormControl = new FormControl('');

    this.prescriptionDuringValueFormControl = new FormControl('');
    this.prescriptionAfterValueFormControl = new FormControl('');
    this.prescriptionStartDateFormControl = new FormControl('');
    this.prescriptionEndDateFormControl = new FormControl('');

    this.applyTherapeuticDuplicationFormControl = new FormControl(false);
    this.applyLevelFourFormControl = new FormControl(false);
    this.applyLevelFourFormControl.disable();
    this.applyLevelFourDosageFormControl = new FormControl(false);
    this.applyLevelFourDosageFormControl.disable();
    this.applyLevelFourDosageIndicatorFormControl = new FormControl(false);
    this.applyLevelFourDosageIndicatorFormControl.disable();
    this.applyLevelFiveFormControl = new FormControl(false);
    this.applyLevelFiveFormControl.disable();
    this.applyLevelFiveDosageFormControl = new FormControl(false);
    this.applyLevelFiveDosageFormControl.disable();
    this.applyLevelFiveDosageIndicatorFormControl = new FormControl(false);
    this.applyLevelFiveDosageIndicatorFormControl.disable();
    this.therapeuticStartDateFormControl = new FormControl('');
    this.therapeuticEndDateFormControl = new FormControl('');

    this.stepTherapyFormControl = new FormControl('none');
    this.stepTherapyStartDateFormControl = new FormControl('');
    this.stepTherapyEndDateFormControl = new FormControl('');

    this.formularyFormControl = new FormControl('');
    this.formularyStartDateFormControl = new FormControl('');
    this.formularyEndDateFormControl = new FormControl('');

    this.grandfatherNameFormControl = new FormControl('');
    this.grandfatherStartDateFormControl = new FormControl('');
    this.grandfatherEndDateFormControl = new FormControl('');

    this.generalFormGroup = this.formBuilder.group({
      drugManagementPlanName: this.drugManagementPlanNameFormControl,
      drugManagementPlanStartDate: this.drugManagementPlanStartDateFormControl,
      drugManagementPlanEndDate: this.drugManagementPlanEndDateFormControl,
      drugManagementPlanPolicy: this.drugManagementPlanPolicyFormControl,
      drugManagementPlanProduct: this.drugManagementPlanProductFormControl
    });

    this.refillParametersFormGroup = this.formBuilder.group({
      refillName: this.refillNameFormControl,
      refillStartDate: this.refillStartDateFormControl,
      refillEndDate: this.refillEndDateFormControl
    });

    this.prescriptionLimitsFormGroup = this.formBuilder.group({
      prescriptionDuringValue: this.prescriptionDuringValueFormControl,
      prescriptionAfterValue: this.prescriptionAfterValueFormControl,
      prescriptionStartDate: this.prescriptionStartDateFormControl,
      prescriptionEndDate: this.prescriptionEndDateFormControl
    });

    this.therapeuticDuplicationsFormGroup = this.formBuilder.group({
      applyTherapeuticDuplication: this.applyTherapeuticDuplicationFormControl,
      applyLevelFour: this.applyLevelFourFormControl,
      applyLevelFourDosage: this.applyLevelFourDosageFormControl,
      applyLevelFourDosageIndicator: this.applyLevelFourDosageIndicatorFormControl,
      applyLevelFive: this.applyLevelFiveFormControl,
      applyLevelFiveDosage: this.applyLevelFiveDosageFormControl,
      applyLevelFiveDosageIndicator: this.applyLevelFiveDosageIndicatorFormControl,
      therapeuticStartDate: this.therapeuticStartDateFormControl,
      therapeuticEndDate: this.therapeuticEndDateFormControl
    });

    this.stepTherapiesFormGroup = this.formBuilder.group({
      // applySteTherapy: this.applyStepTherapyFormControl,
      stepTherapy: this.stepTherapyFormControl,
      stepTherapyStartDate: this.stepTherapyStartDateFormControl,
      stepTherapyEndDate: this.stepTherapyEndDateFormControl,
      stepTherapies: this.formBuilder.array(
        [],
        [Validators.minLength(1)]
      )
    });

    this.formulariesFormGroup = this.formBuilder.group({
      formulary: this.formularyFormControl,
      formularyStartDate: this.formularyStartDateFormControl,
      formularyEndDate: this.formularyEndDateFormControl,
      formularies: this.formBuilder.array(
        [],
        [Validators.minLength(1)]
      )
    });

    this.grandfatherFormGroup = this.formBuilder.group({
      grandfatherName: this.grandfatherNameFormControl,
      grandfatherStartDate: this.grandfatherStartDateFormControl,
      grandfatherEndDate: this.grandfatherEndDateFormControl
    });

    this.refillNameSubscription = this.refillNameTextChanged.pipe(
      debounceTime(this.debounceTime),
    ).subscribe(() => this.getFilteredListOfRefills());

    this.formularyNameSubscription = this.formularyTextChanged.pipe(
      debounceTime(this.debounceTime),
    ).subscribe(() => this.getFilteredListOfFormularies());

    this.grandfatherNameSubscription = this.grandfatherNameTextChanged.pipe(
      debounceTime(this.debounceTime),
    ).subscribe(() => this.getFilteredListOfGrandfathers());
  }

  get stepTherapies() {
    return this.stepTherapiesFormGroup.get('stepTherapies') as FormArray;
  }

  get formularies() {
    return this.formulariesFormGroup.get('formularies') as FormArray;
  }

  ngOnInit(): void {
    if (this.route.snapshot.url[1].path === 'edit-drug-management-plan') {
      this.isEdit = true;
      this.route.paramMap.subscribe((params) => {
        this.getDrugManagementPlan(Number(params.get('id')));
      });
    }

    this.disableGeneralFormField();

    // TODO: needs to be set as an autocomplete - too many policies for a drop down list
    // this.getListOfLookupValues('policy');
    this.getListOfLookupValues(this.lookupValue.Product);
    this.getListOfLookupValues(this.lookupValue.PrescriptionLimitType);
    this.getListOfLookupValues(this.lookupValue.StepTherapy);

    this.getHelpInfo('drug_management_plan');

    this.keycloakService.loadUserProfile().then((profile) => {
      this.userFirstLastName = `${profile.firstName} ${profile.lastName}`;
    });

    this.getFilteredListOfRefills(false);
    this.getFilteredListOfFormularies(false);
    this.getFilteredListOfGrandfathers(false);
  }

  ngAfterViewChecked(): void {
    this.changeDetect.detectChanges();
  }

  ngOnDestroy(): void {
    this.refillNameSubscription.unsubscribe();
    this.formularyNameSubscription.unsubscribe();
    this.grandfatherNameSubscription.unsubscribe();
  }

  getDrugManagementPlan(drugManagementPlanId: number) {
    this.drugManagementPlanService.getDrugManagementPlan(drugManagementPlanId).subscribe(
      (response) => {
        this.editDrugManagementPlan = response;
        this.populateArrays();
        this.populateForms();
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.sharedService.openErrorDialog(error.businessMessage);
      }
    );
  }

  populateForms() {
    // General
    this.drugManagementPlanNameFormControl.setValue(this.editDrugManagementPlan.name);
    this.drugManagementPlanPolicyFormControl.setValue(this.editDrugManagementPlan.policy != null ? this.editDrugManagementPlan.policy.name : '');
    this.drugManagementPlanProductFormControl.setValue(
      this.editDrugManagementPlan.product != null ? this.editDrugManagementPlan.product.name : ''
    );
    this.drugManagementPlanStartDateFormControl.setValue(new Date(this.editDrugManagementPlan.startDate));
    this.drugManagementPlanEndDateFormControl.setValue(this.getFormValueFromEndDate(this.editDrugManagementPlan.endDate));
    this.chosenPlanApplication = this.editDrugManagementPlan.policy != null ? 'Policy' : 'Product';
    this.generalStartDate = new Date(this.editDrugManagementPlan.startDate);
    this.generalEndDate = new Date(this.editDrugManagementPlan.endDate);
    this.disableGeneralFormField();

    // Refill
    this.chosenRefillOption = 'Current';
    this.refillSelected(this.dmpRefills[0].refill.name);
    this.refillNameFormControl.setValue(this.getRefillDisplayString(this.dmpRefills[0].refill));
    this.refillStartDateFormControl.setValue(new Date(this.dmpRefills[0].startDate));
    this.refillEndDateFormControl.setValue(this.getFormValueFromEndDate(this.dmpRefills[0].endDate));
    this.refillNameFormControl.disable();
    this.refillEndDateFormControl.disable();
    this.refillStartDateFormControl.disable();
    this.addRefillText = 'Edit';

    // Prescription
    this.chosenPrescriptionOption = 'Current';
    this.prescriptionDuringValueFormControl.setValue(this.dmpPrescriptions[0].value);
    this.prescriptionAfterValueFormControl.setValue(this.dmpPrescriptions[1].value);
    this.prescriptionStartDateFormControl.setValue(new Date(this.dmpPrescriptions[0].startDate));
    this.prescriptionEndDateFormControl.setValue(this.getFormValueFromEndDate(this.dmpPrescriptions[0].endDate));
    this.prescriptionDuringValueFormControl.disable();
    this.prescriptionAfterValueFormControl.disable();
    this.prescriptionStartDateFormControl.disable();
    this.prescriptionEndDateFormControl.disable();

    // Therapeutic Duplication
    this.chosenTherapeuticOption = 'Current';
    this.applyTherapeuticDuplicationFormControl.setValue(this.dmpTherapeuticDuplications[0].applyTherapeuticDuplication);
    this.applyLevelFourFormControl.setValue(this.dmpTherapeuticDuplications[0].applyLevelFour);
    this.applyLevelFourDosageFormControl.setValue(this.dmpTherapeuticDuplications[0].applyLevelFourDosage);
    this.applyLevelFourDosageIndicatorFormControl.setValue(this.dmpTherapeuticDuplications[0].levelFourDosageIndicator);
    this.applyLevelFiveFormControl.setValue(this.dmpTherapeuticDuplications[0].applyLevelFive);
    this.applyLevelFiveDosageFormControl.setValue(this.dmpTherapeuticDuplications[0].applyLevelFiveDosage);
    this.applyLevelFiveDosageIndicatorFormControl.setValue(this.dmpTherapeuticDuplications[0].levelFiveDosageIndicator);
    this.therapeuticStartDateFormControl.setValue(new Date(this.dmpTherapeuticDuplications[0].startDate));
    this.therapeuticEndDateFormControl.setValue(this.getFormValueFromEndDate(this.dmpTherapeuticDuplications[0].endDate));
    this.applyTherapeuticDuplicationFormControl.disable();
    this.applyLevelFourFormControl.disable();
    this.applyLevelFourDosageFormControl.disable();
    this.applyLevelFourDosageIndicatorFormControl.disable();
    this.applyLevelFiveFormControl.disable();
    this.applyLevelFiveDosageFormControl.disable();
    this.applyLevelFiveDosageIndicatorFormControl.disable();
    this.therapeuticStartDateFormControl.disable();
    this.therapeuticEndDateFormControl.disable();

    // Step Therapies
    this.stepTherapyFormControl.setValue(this.dmpStepTherapies[0].stepTherapy.name === 'none' ? 'none' : '');
    this.chosenStepTherapyOption = 'Current';
    const currentStepTherapies = this.dmpStepTherapies.filter((stepTherapy) => stepTherapy.startDate === this.dmpStepTherapies[0].startDate);
    currentStepTherapies.forEach((stepTherapyLink) => {
      if (stepTherapyLink.stepTherapy.name !== 'none') {
        this.stepTherapies.push(
          new FormGroup({
            stepTherapy: new FormControl(stepTherapyLink.stepTherapy.name)
          })
        );
      }
    });
    this.stepTherapyStartDateFormControl.setValue(new Date(this.dmpStepTherapies[0].startDate));
    this.stepTherapyEndDateFormControl.setValue(this.getFormValueFromEndDate(this.dmpStepTherapies[0].endDate));
    this.stepTherapyFormControl.disable();
    this.stepTherapies.disable();
    this.stepTherapyStartDateFormControl.disable();
    this.stepTherapyEndDateFormControl.disable();

    // Formularies
    this.chosenFormularyOption = 'Current';
    const currentFormularies = this.dmpFormularies.filter((formulary) => formulary.startDate === this.dmpFormularies[0].startDate);
    currentFormularies.forEach((formularyLink) => {
      this.formularies.push(
        new FormGroup({
          formulary: new FormControl(this.getFormularyDisplayString(formularyLink.nationalDrugFormulary))
        })
      );
    });

    const hasFormularies = this.dmpFormularies && this.dmpFormularies.length > 0;
    const startDate = hasFormularies ? new Date(this.dmpFormularies[0].startDate) : null;
    const endDate = hasFormularies ? this.dmpFormularies[0].endDate : null;

    this.formularyStartDateFormControl.setValue(startDate);
    this.formularyEndDateFormControl.setValue(this.getFormValueFromEndDate(endDate));
    this.formularyFormControl.disable();
    this.formularies.disable();
    this.formularyStartDateFormControl.disable();
    this.formularyEndDateFormControl.disable();

    // Grandfather
    this.chosenGrandfatherOption = 'Current';
    this.grandfatherSelected(this.dmpGrandfathers[0].grandfather.name);
    this.grandfatherNameFormControl.setValue(this.getGrandfatherDisplayString(this.dmpGrandfathers[0].grandfather));
    this.grandfatherStartDateFormControl.setValue(new Date(this.dmpGrandfathers[0].startDate));
    this.grandfatherEndDateFormControl.setValue(this.getFormValueFromEndDate(this.dmpGrandfathers[0].endDate));
    this.grandfatherNameFormControl.disable();
    this.grandfatherEndDateFormControl.disable();
    this.grandfatherStartDateFormControl.disable();
    this.addGrandfatherText = 'Edit';

  }

  populateArrays() {
    // Refills
    if (this.editDrugManagementPlan.refills != null) {
      this.dmpRefills = this.editDrugManagementPlan.refills.sort((o1, o2) => {
        return this.compareByDate(o1, o2);
      });
    }

    // Prescriptions
    if (this.editDrugManagementPlan.prescriptionLimits != null) {
      this.dmpPrescriptions = this.editDrugManagementPlan.prescriptionLimits.sort((o1, o2) => {
        if (o1.startDate > o2.startDate) {
          return -1;
        }
        else if (o1.startDate < o2.startDate) {
          return 1;
        }
        else {
          if (o1.prescriptionLimitType.value > o2.prescriptionLimitType.value) {
            return 1;
          }
          else if (o1.prescriptionLimitType.value < o2.prescriptionLimitType.value) {
            return -1;
          }
        }

        return 0;
      });
    }

    // Therapeutic Duplications
    if (this.editDrugManagementPlan.therapeuticDuplications != null) {
      this.dmpTherapeuticDuplications = this.editDrugManagementPlan.therapeuticDuplications.sort((o1, o2) => {
        return this.compareByDate(o1, o2);
      });
    }

    // Step Therapies
    if (this.editDrugManagementPlan.stepTherapies != null) {
      this.dmpStepTherapies = this.editDrugManagementPlan.stepTherapies.sort((o1, o2) => {
        return this.compareByDate(o1, o2);
      });
    }

    // Formularies
    if (this.editDrugManagementPlan.nationalDrugFormularies != null) {
      this.dmpFormularies = this.editDrugManagementPlan.nationalDrugFormularies.sort((o1, o2) => {
        return this.compareByDate(o1, o2);
      });
    }

    // Grandfathers
    if (this.editDrugManagementPlan.grandfathers != null) {
      this.dmpGrandfathers = this.editDrugManagementPlan.grandfathers.sort((o1, o2) => {
        return this.compareByDate(o1, o2);
      });
    }

  }

  compareByDate(o1: any, o2: any): number {
    if (o1.startDate > o2.startDate) {
      return -1;
    }
    else if (o1.startDate < o2.startDate) {
      return 1;
    }

    return 0;
  }

  compareByName(o1: any, o2: any): number {
    if (o1.name > o2.name) {
      return -1;
    }
    else if (o1.name < o2.name) {
      return 1;
    }

    return 0;
  }

  getListOfLookupValues(entity: string): void {
    this.lookupService.getListOfLookupValues(entity).subscribe(
      (response: NameValueDTO[]) => {
        if (entity === this.lookupValue.Policy) {
          this.policies = response;
        }
        else if (entity === this.lookupValue.Product) {
          this.products = response;
        }
        else if (entity === this.lookupValue.PrescriptionLimitType) {
          this.prescriptionLimitTypes = response;
        }
        else if (entity === this.lookupValue.StepTherapy) {
          this.displayedStepTherapies = response;
          this.removedStepTherapies = [];
        }
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.sharedService.openErrorDialog(error.businessMessage);
      }
    );
  }

  getHelpInfo(componentName: string) {
    this.helpService.getListOfHelpInfo(componentName).subscribe(
      (response) => {
        this.helpInfo = response;
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.sharedService.openErrorDialog(error.businessMessage);
      }
    );
  }

  addStepTherapy() {
    const selectedTherapyName = this.stepTherapyFormControl.value;

    if (selectedTherapyName === 'none') {
      this.displayedStepTherapies = this.displayedStepTherapies.concat(this.removedStepTherapies).sort((o1, o2) => {
        return this.compareByName(o1, o2);
      });
      this.removedStepTherapies = [];
      this.stepTherapies.clear();
    }
    else {
      const group = new FormGroup({
        stepTherapy: new FormControl(selectedTherapyName)
      });
      group.disable();
      this.stepTherapies.push(group);

      const selectedTherapy = this.displayedStepTherapies.find(therapy => therapy.name === selectedTherapyName);
      this.removedStepTherapies.push(selectedTherapy);
      const deleteIndex = this.displayedStepTherapies.indexOf(selectedTherapy);
      this.displayedStepTherapies.splice(deleteIndex, 1);

      this.stepTherapyFormControl.setValue('');
    }
  }

  removeStepTherapy(index: number) {
    const removedTherapyName = this.stepTherapies.controls[index].value.stepTherapy;

    const removedTherapy = this.removedStepTherapies.find(therapy => therapy.name === removedTherapyName);
    this.displayedStepTherapies.push(removedTherapy);
    this.displayedStepTherapies.sort((o1, o2) => {
      return this.compareByName(o1, o2);
    });
    const deleteIndex = this.removedStepTherapies.indexOf(removedTherapy);
    this.removedStepTherapies.splice(deleteIndex, 1);

    this.stepTherapies.removeAt(index);
  }

  addFormulary() {
    const selectedFormulary = this.filteredFormularies.find(
      (item) => this.formularyFormControl.value.includes(item.name)
    );
    if (selectedFormulary != null && !this.formularyHasBeenSelected(selectedFormulary)
    ) {
      const group = new FormGroup({
        formulary: new FormControl(this.formularyFormControl.value),
        formularyClass: new FormControl(''),
        formularyStartDate: new FormControl(''),
        formularyEndDate: new FormControl('')
      });
      group.disable();

      this.formularies.push(group);
    }
    else {
      this.sharedService.openSnackBar('The chosen formulary class has already been selected, or The chosen formulary is invalid', 'Dismiss');
    }
    this.formularyFormControl.setValue('');
    this.getFilteredListOfFormularies(false);

  }

  formularyHasBeenSelected(formulary: NationalDrugFormularyDTO): boolean {
    let hasBeenSelected = false;

    const formularyGrpList = this.formularies.controls;
    for (let i = 0; i < formularyGrpList.length; i++) {
      if (formularyGrpList[i].value.formulary.includes(formulary.name)) {
        hasBeenSelected = true;
      }
      else if (formularyGrpList[i].value.formulary.includes(formulary.formularyClass.name)) {
        hasBeenSelected = true;
      }
    }

    return hasBeenSelected;
  }

  removeFormulary(index: number) {
    this.formularies.removeAt(index);
  }

  openDialog(displayHeading: string): void {

    const displayList: string[] = [];

    if (displayHeading === 'Refill') {
      displayList.push('Name;Measurement;Value');
      const displayString = `${this.selectedRefill.name};${this.selectedRefill.refillMeasurement.name};${this.selectedRefill.refillValue}`;
      displayList.push(displayString);
    }
    else if (displayHeading === 'Step Therapy(ies)') {
      const stepTherapiesGrpList = this.stepTherapies.controls;
      for (let i = 0; i < stepTherapiesGrpList.length; i++) {
        const displayString = `${stepTherapiesGrpList[i].value.stepTherapy}`;
        displayList.push(displayString);
      }
    }
    else if (displayHeading === 'Formulary(ies)') {
      const formularyGrpList = this.formularies.controls;
      for (let i = 0; i < formularyGrpList.length; i++) {
        const displayString = `${formularyGrpList[i].value.formulary}`;
        displayList.push(displayString);
      }
    }
    else if (displayHeading === 'Grandfather') {
      displayList.push('Name;Policy;Insured Person');
      const displayString = `${this.selectedGrandfather.name};
                              ${this.selectedGrandfather.policy != null ? this.selectedGrandfather.policy.name : ''};
                              ${this.selectedGrandfather.insuredPerson != null ? this.selectedGrandfather.insuredPerson.name : ''}`;
      displayList.push(displayString);
    }

    const dialogRef = this.dialog.open(GenericListDialogComponent, {
      width: '40vw',
      data: {list: displayList, heading: displayHeading}
    });
  }

  openRefillDialog() {
    const dialogRef = this.dialog.open(AddRefillDialogComponent, {
      width: '40vw',
      data: this.selectedRefill == null ? null : this.selectedRefill.refillId
    });
  }

  openGrandfatherDialog() {
    const dialogRef = this.dialog.open(AddGrandfatherDialogComponent, {
      width: '40vw',
      data: this.selectedGrandfather == null ? null : this.selectedGrandfather.grandfatherId
    });
  }

  disableGeneralFormField() {
    if (this.chosenPlanApplication === 'Policy') {
      this.drugManagementPlanProductFormControl.setValue('');
      this.drugManagementPlanPolicyFormControl.setValue(
        this.editDrugManagementPlan.policy != null ? this.editDrugManagementPlan.policy.name : ''
      );

      this.drugManagementPlanProductFormControl.disable();
      this.drugManagementPlanPolicyFormControl.enable();
    }
    else if (this.chosenPlanApplication === 'Product') {
      this.drugManagementPlanProductFormControl.setValue(
        this.editDrugManagementPlan.product != null ? this.editDrugManagementPlan.product.name : ''
      );
      this.drugManagementPlanPolicyFormControl.setValue('');

      this.drugManagementPlanProductFormControl.enable();
      this.drugManagementPlanPolicyFormControl.disable();
    }
  }

  generalNext() {
    if (this.generalFormGroup.valid && this.generalFormHasValue()) {
      this.drugManagementPlanStepper.next();
    }
    else {
      this.sharedService.openSnackBar('Ensure that either a policy OR product is chosen and that all required fields are completed', 'Dismiss');
    }
  }

  refillNext() {
    if (this.refillParametersFormGroup.valid || (this.chosenRefillOption === 'Current' && this.isEdit)) {// TODO improve the flow of this logic and Next() methods below
      if (this.chosenRefillOption === 'New' && this.isEdit) {

        const confirmationMessage =
          `This will set the end date on ${this.dmpRefills[0].refill.name} to ${this.datePipe.transform(this.addDays(new Date(this.refillStartDateFormControl.value), -1), this.dateFormat)}.\nAre you sre you wish to proceed?`;

        this.openConfirmationObsrvable(confirmationMessage).subscribe((isConfirmed) => {
          if (isConfirmed) {
            this.drugManagementPlanStepper.next();
          }
        });
      }
      else {
        this.drugManagementPlanStepper.next();
      }
    }
    else {
      this.sharedService.openSnackBar(ALERT_MESSAGE, 'Dismiss');
    }
  }

  prescriptionNext() {
    if (this.prescriptionLimitsFormGroup.valid || (this.chosenPrescriptionOption === 'Current' && this.isEdit)) {
      if (this.chosenPrescriptionOption === 'New' && this.isEdit) {

        const confirmationMessage =
          `This will set the end date on the previous prescription limits to ${this.datePipe.transform(this.addDays(new Date(this.prescriptionStartDateFormControl.value), -1), this.dateFormat)}.\nAre you sre you wish to proceed?`;

        this.openConfirmationObsrvable(confirmationMessage).subscribe((isConfirmed) => {
          if (isConfirmed) {
            this.drugManagementPlanStepper.next();
          }
        });
      }
      else {
        this.drugManagementPlanStepper.next();
      }
    }
    else {
      this.sharedService.openSnackBar(ALERT_MESSAGE, 'Dismiss');
    }
  }

  therapeuticNext() {
    if (this.therapeuticDuplicationsFormGroup.valid || (this.chosenTherapeuticOption === 'Current' && this.isEdit)) {
      if (this.chosenTherapeuticOption === 'New' && this.isEdit) {

        const confirmationmessage =
          `This will set the end date on the previous therapeutic duplication parameters to ${this.datePipe.transform(this.addDays(new Date(this.therapeuticStartDateFormControl.value), -1), this.dateFormat)}.\nAre you sre you wish to proceed?`;

        this.openConfirmationObsrvable(confirmationmessage).subscribe((result) => {
          const isConfirmed = result;

          if (isConfirmed) {
            this.drugManagementPlanStepper.next();
          }
        });
      }
      else {
        this.drugManagementPlanStepper.next();
      }
    }
    else {
      this.sharedService.openSnackBar(ALERT_MESSAGE, 'Dismiss');
    }
  }

  stepTherapyNext() {
    if (this.stepTherapiesFormGroup.valid || (this.chosenStepTherapyOption === 'Current' && this.isEdit)) {
      if (this.chosenStepTherapyOption === 'New' && this.isEdit) {
        const confirmationMessage =
          `This will set the end date on the previous step therapies to ${this.datePipe.transform(this.addDays(new Date(this.stepTherapyStartDateFormControl.value), -1), this.dateFormat)}.\nAre you sre you wish to proceed?`;

        this.openConfirmationObsrvable(confirmationMessage).subscribe((result) => {
          const isConfirmed = result;

          if (isConfirmed) {
            this.drugManagementPlanStepper.next();
          }
        });
      }
      else {
        this.drugManagementPlanStepper.next();
      }
    }
    else {
      this.sharedService.openSnackBar(ALERT_MESSAGE, 'Dismiss');
    }
  }

  formularyNext() {
    if (this.formulariesFormGroup.valid || (this.chosenFormularyOption === 'Current' && this.isEdit)) {
      if (this.chosenFormularyOption === 'New' && this.isEdit) {
        const confirmationMessage =
          `This will set the end date on the previous formularies to ${this.datePipe.transform(this.addDays(new Date(this.formularyStartDateFormControl.value), -1), this.dateFormat)}.\nAre you sre you wish to proceed?`;

        this.openConfirmationObsrvable(confirmationMessage).subscribe((result) => {
          const isConfirmed = result;

          if (isConfirmed) {
            this.drugManagementPlanStepper.next();
          }
        });
      }
      else {
        this.drugManagementPlanStepper.next();
      }
    }
    else {
      this.sharedService.openSnackBar(ALERT_MESSAGE, 'Dismiss');
    }
  }

  grandfatherNext() {
    if (this.grandfatherFormGroup.valid || (this.chosenGrandfatherOption === 'Current' && this.isEdit)) {
      if (this.chosenGrandfatherOption === 'New' && this.isEdit) {

        const confirmationMessage =
          `This will set the end date on ${this.dmpGrandfathers[0].grandfather.name} to ${this.datePipe.transform(this.addDays(new Date(this.grandfatherStartDateFormControl.value), -1), this.dateFormat)}.\nAre you sre you wish to proceed?`;

        this.openConfirmationObsrvable(confirmationMessage)
          .subscribe((result) => {
            const isConfirmed = result;

            if (isConfirmed) {
              this.drugManagementPlanStepper.next();
            }
          });
      }
      else {
        this.drugManagementPlanStepper.next();
      }
    }
    else {
      this.sharedService.openSnackBar(ALERT_MESSAGE, 'Dismiss');
    }
  }

  generalFormHasValue(): boolean {
    let selectedInputHasValue = false;
    if (this.chosenPlanApplication === 'Policy'
      && this.drugManagementPlanPolicyFormControl.value !== ''
      && this.drugManagementPlanProductFormControl.value === ''
    ) {
      selectedInputHasValue = true;
    }
    if (this.chosenPlanApplication === 'Product'
      && this.drugManagementPlanProductFormControl.value !== ''
      && this.drugManagementPlanPolicyFormControl.value === '') {
      selectedInputHasValue = true;
    }
    return selectedInputHasValue;
  }

  getInfoTooltip(inputName: string): string {
    let message = '';
    if (this.helpInfo != null) {
      const helpInfo = this.helpInfo.find((help) => help.inputName === inputName);
      message = helpInfo != null ? helpInfo.inputInfo : '';
    }
    return message;
  }

  onInputChangedSearchRefills($event) {
    this.refillNameTextChanged.next($event.target.value);
  }

  onInputChangedSearchFormularies($event) {
    this.formularyTextChanged.next($event.target.value);
  }

  onInputChangedSearchGrandfathers($event) {
    this.grandfatherNameTextChanged.next($event.target.value);
  }

  getFilteredListOfRefills(isFilter: boolean = true): void {
    const pagedRequestDTO = new PagedRequestDTO();
    pagedRequestDTO.entityClass = EntityTable.TblRefill;
    pagedRequestDTO.pageNumber = 0;
    pagedRequestDTO.pageSize = 100;

    if (isFilter) {
      pagedRequestDTO.fieldMap = createFieldMap(
        'name',
        this.refillNameFormControl.value
      );
    }

    this.refillService.getListOfRefills(pagedRequestDTO).subscribe(
      (response) => {
        this.filteredRefills = response.resultList;
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.sharedService.openErrorDialog(error.businessMessage);
      }
    );
  }

  getFilteredListOfFormularies(isFilter: boolean = true): void {
    const pagedRequestDTO = new PagedRequestDTO();
    pagedRequestDTO.entityClass = EntityTable.TblNationalDrugFormulary;
    pagedRequestDTO.pageNumber = 0;
    pagedRequestDTO.pageSize = 100;

    if (isFilter) {
      pagedRequestDTO.fieldMap = createFieldMap(
        'name',
        this.formularyFormControl.value
      );
    }

    this.nationalDrugFormularyService.getListOfNationalDrugFormularies(pagedRequestDTO).subscribe(
      (response) => {
        this.filteredFormularies = response.resultList;
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.sharedService.openErrorDialog(error.businessMessage);
      }
    );
  }

  getFilteredListOfGrandfathers(isFilter: boolean = true): void {
    const pagedRequestDTO = new PagedRequestDTO();
    pagedRequestDTO.entityClass = EntityTable.TblGrandfather;
    pagedRequestDTO.pageNumber = 0;
    pagedRequestDTO.pageSize = 100;

    if (isFilter) {
      pagedRequestDTO.fieldMap = createFieldMap('name', this.grandfatherNameFormControl.value);
    }

    this.grandfatherService.getListOfGrandfathers(pagedRequestDTO).subscribe(
      (response) => {
        this.filteredGrandfathers = response.resultList;
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.sharedService.openErrorDialog(error.businessMessage);
      }
    );
  }


  blurRefillName() {
    if (
      this.filteredRefills != null &&
      this.filteredRefills.find(
        (item) => this.getRefillDisplayString(item) === this.refillNameFormControl.value
      ) == null
    ) {
      this.refillNameFormControl.reset();
      this.selectedRefill = null;
      this.addRefillText = 'Add';
    }
  }

  blurFormulary() {
    if (
      this.filteredFormularies != null &&
      this.filteredFormularies.find(
        (item) => this.getFormularyDisplayString(item) === this.formularyFormControl.value
      ) == null
    ) {
      this.formularyFormControl.reset();
    }
  }

  blurGrandfatherName() {
    if (
      this.filteredGrandfathers != null &&
      this.filteredGrandfathers.find(
        (item) => this.getGrandfatherDisplayString(item) === this.grandfatherNameFormControl.value
      ) == null
    ) {
      this.grandfatherNameFormControl.reset();
      this.selectedGrandfather = null;
      this.addGrandfatherText = 'Add';
    }
  }

  refillSelected(name: string) {
    if (this.filteredRefills != null) {
      this.selectedRefill = this.filteredRefills.find((item) => name.includes(item.name));
      this.addRefillText = 'Edit';
    }
  }

  // Todo: Test this method
  grandfatherSelected(name: string) {
    if (this.filteredGrandfathers != null) {
      this.selectedGrandfather = this.filteredGrandfathers.find((item) => name.includes(item.name));
      this.addGrandfatherText = 'Edit';
    }
  }

  clearRefillName() {
    this.refillNameFormControl.reset();
    this.selectedRefill = null;
    this.addRefillText = 'Add';
    this.filteredRefills = [];
  }

  clearGrandfatherName() {
    this.grandfatherNameFormControl.reset();
    this.selectedGrandfather = null;
    this.addGrandfatherText = 'Add';
    this.filteredGrandfathers = [];
  }

  refillOptionChange(event: any) {
    if (event.value === 'Current' && this.dmpRefills.length > 0) {
      this.refillSelected(this.dmpRefills[0].refill.name);

      this.refillNameFormControl.setValue(this.getRefillDisplayString(this.dmpRefills[0].refill));
      this.refillStartDateFormControl.setValue(new Date(this.dmpRefills[0].startDate));
      this.refillEndDateFormControl.setValue(this.getFormValueFromEndDate(this.dmpRefills[0].endDate));

      this.refillNameFormControl.disable();
      this.refillEndDateFormControl.disable();
      this.refillStartDateFormControl.disable();

      this.addRefillText = 'Edit';
    }
    else {
      this.selectedRefill = null;

      this.refillNameFormControl.setValue('');
      this.refillEndDateFormControl.setValue('');
      this.refillStartDateFormControl.setValue('');

      this.refillNameFormControl.enable();
      this.refillEndDateFormControl.enable();
      this.refillStartDateFormControl.enable();

      this.addRefillText = 'Add';
    }
  }

  prescriptionOptionChange(event: any) {
    if (event.value === 'Current' && this.dmpPrescriptions.length > 0) {
      this.prescriptionDuringValueFormControl.setValue(this.dmpPrescriptions[0].value);
      this.prescriptionAfterValueFormControl.setValue(this.dmpPrescriptions[1].value);
      this.prescriptionStartDateFormControl.setValue(new Date(this.dmpPrescriptions[0].startDate));
      this.prescriptionEndDateFormControl.setValue(this.getFormValueFromEndDate(this.dmpPrescriptions[0].endDate));

      this.prescriptionDuringValueFormControl.disable();
      this.prescriptionAfterValueFormControl.disable();
      this.prescriptionStartDateFormControl.disable();
      this.prescriptionEndDateFormControl.disable();
    }
    else {
      this.prescriptionDuringValueFormControl.setValue('');
      this.prescriptionAfterValueFormControl.setValue('');
      this.prescriptionStartDateFormControl.setValue('');
      this.prescriptionEndDateFormControl.setValue('');

      this.prescriptionDuringValueFormControl.enable();
      this.prescriptionAfterValueFormControl.enable();
      this.prescriptionStartDateFormControl.enable();
      this.prescriptionEndDateFormControl.enable();
    }
  }

  therapeuticOptionChange(event: any) {
    if (event.value === 'Current' && this.dmpTherapeuticDuplications.length > 0) {
      this.applyTherapeuticDuplicationFormControl.setValue(this.dmpTherapeuticDuplications[0].applyTherapeuticDuplication);
      this.applyLevelFourFormControl.setValue(this.dmpTherapeuticDuplications[0].applyLevelFour);
      this.applyLevelFourDosageFormControl.setValue(this.dmpTherapeuticDuplications[0].applyLevelFourDosage);
      this.applyLevelFourDosageIndicatorFormControl.setValue(this.dmpTherapeuticDuplications[0].levelFourDosageIndicator);
      this.applyLevelFiveFormControl.setValue(this.dmpTherapeuticDuplications[0].applyLevelFive);
      this.applyLevelFiveDosageFormControl.setValue(this.dmpTherapeuticDuplications[0].applyLevelFive);
      this.applyLevelFiveDosageIndicatorFormControl.setValue(this.dmpTherapeuticDuplications[0].levelFiveDosageIndicator);
      this.therapeuticStartDateFormControl.setValue(new Date(this.dmpTherapeuticDuplications[0].startDate));
      this.therapeuticEndDateFormControl.setValue(this.getFormValueFromEndDate(this.dmpTherapeuticDuplications[0].endDate));

      this.applyTherapeuticDuplicationFormControl.disable();
      this.applyLevelFourFormControl.disable();
      this.applyLevelFourDosageFormControl.disable();
      this.applyLevelFourDosageIndicatorFormControl.disable();
      this.applyLevelFiveFormControl.disable();
      this.applyLevelFiveDosageFormControl.disable();
      this.applyLevelFiveDosageIndicatorFormControl.disable();
      this.therapeuticStartDateFormControl.disable();
      this.therapeuticEndDateFormControl.disable();
    }
    else {
      this.applyTherapeuticDuplicationFormControl.setValue('');
      this.applyLevelFourFormControl.setValue('');
      this.applyLevelFourDosageFormControl.setValue('');
      this.applyLevelFourDosageIndicatorFormControl.setValue(false);
      this.applyLevelFiveFormControl.setValue('');
      this.applyLevelFiveDosageFormControl.setValue('');
      this.applyLevelFiveDosageIndicatorFormControl.setValue(false);
      this.therapeuticStartDateFormControl.setValue('');
      this.therapeuticEndDateFormControl.setValue('');

      this.applyTherapeuticDuplicationFormControl.enable();
      if (this.therapeuticDuplicationEnabled()) {
        this.applyLevelFourFormControl.enable();
        this.applyLevelFiveFormControl.enable();
      }
      if (this.levelFourEnabled()) {
        this.applyLevelFourDosageFormControl.enable();
        this.applyLevelFourDosageIndicatorFormControl.enable();
      }
      if (this.levelFiveEnabled()) {
        this.applyLevelFiveDosageFormControl.enable();
        this.applyLevelFiveDosageIndicatorFormControl.enable();
      }
      this.therapeuticStartDateFormControl.enable();
      this.therapeuticEndDateFormControl.enable();
    }
  }

  stepTherapyOptionChange(event: any) {
    if (event.value === 'Current' && this.dmpStepTherapies.length > 0) {
      this.stepTherapyFormControl.setValue(this.dmpStepTherapies[0].stepTherapy.name === 'none' ? 'none' : '');
      const currentStepTherapies = this.dmpStepTherapies.filter((stepTherapy) => stepTherapy.startDate === this.dmpStepTherapies[0].startDate);
      currentStepTherapies.forEach((stepTherapyLink) => {
        if (stepTherapyLink.stepTherapy.name !== 'none') {
          this.stepTherapies.push(
            new FormGroup({
              stepTherapy: new FormControl(stepTherapyLink.stepTherapy.name)
            })
          );
        }
      });
      this.stepTherapyStartDateFormControl.setValue(new Date(this.dmpStepTherapies[0].startDate));
      this.stepTherapyEndDateFormControl.setValue(this.getFormValueFromEndDate(this.dmpStepTherapies[0].endDate));

      this.stepTherapyFormControl.disable();
      this.stepTherapies.disable();
      this.stepTherapyStartDateFormControl.disable();
      this.stepTherapyEndDateFormControl.disable();
    }
    else {
      this.stepTherapyFormControl.setValue('none');
      this.stepTherapies.clear();
      this.stepTherapyStartDateFormControl.setValue('');
      this.stepTherapyEndDateFormControl.setValue('');

      this.stepTherapyFormControl.enable();
      this.stepTherapies.enable();
      this.stepTherapyStartDateFormControl.enable();
      this.stepTherapyEndDateFormControl.enable();
    }
  }

  formularyOptionChange(event: any) {
    if (event.value === 'Current' && this.dmpFormularies.length > 0) {
      const currentFormularies = this.dmpFormularies.filter((formulary) => formulary.startDate === this.dmpFormularies[0].startDate);
      currentFormularies.forEach((formularyLink) => {
        this.formularies.push(
          new FormGroup({
            formulary: new FormControl(this.getFormularyDisplayString(formularyLink.nationalDrugFormulary))
          })
        );
      });

      const hasFormularies = this.dmpFormularies && this.dmpFormularies.length > 0;
      const startDate = hasFormularies ? new Date(this.dmpFormularies[0].startDate) : null;
      const endDate = hasFormularies ? new Date(this.dmpFormularies[0].endDate) : null;

      this.formularyStartDateFormControl.setValue(startDate);
      this.formularyEndDateFormControl.setValue(this.getFormValueFromEndDate(endDate));

      this.formularyFormControl.disable();
      this.formularies.disable();
      this.formularyStartDateFormControl.disable();
      this.formularyEndDateFormControl.disable();
    }
    else {
      this.formularies.clear();
      this.formularyStartDateFormControl.setValue('');
      this.formularyEndDateFormControl.setValue('');

      this.formularyFormControl.enable();
      this.formularies.enable();
      this.formularyStartDateFormControl.enable();
      this.formularyEndDateFormControl.enable();
    }
  }

  grandfatherOptionChange(event: any) {
    if (event.value === 'Current' && this.dmpGrandfathers.length > 0) {
      this.grandfatherSelected(this.dmpGrandfathers[0].grandfather.name);

      this.grandfatherNameFormControl.setValue(this.getGrandfatherDisplayString(this.dmpGrandfathers[0].grandfather));
      this.grandfatherStartDateFormControl.setValue(new Date(this.dmpGrandfathers[0].startDate));
      this.grandfatherEndDateFormControl.setValue(this.getFormValueFromEndDate(this.dmpGrandfathers[0].endDate));

      this.grandfatherNameFormControl.disable();
      this.grandfatherEndDateFormControl.disable();
      this.grandfatherStartDateFormControl.disable();

      this.addGrandfatherText = 'Edit';
    }
    else {
      this.selectedGrandfather = null;

      this.grandfatherNameFormControl.setValue('');
      this.grandfatherEndDateFormControl.setValue('');
      this.grandfatherStartDateFormControl.setValue('');

      this.grandfatherNameFormControl.enable();
      this.grandfatherEndDateFormControl.enable();
      this.grandfatherStartDateFormControl.enable();

      this.addGrandfatherText = 'Add';
    }
  }

  deleteRefill() {
    const id = this.selectedRefill.refillId;
    this.refillService.deleteRefill(id).subscribe(
      () => {
        this.sharedService.openSnackBar(`Refill ${id} deleted`, 'Dismiss');
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.sharedService.openErrorDialog(error.businessMessage);
      }
    );
  }

  deleteGrandfather() {
    const id = this.selectedGrandfather.grandfatherId;
    this.grandfatherService.deleteGrandfather(id).subscribe(
      () => {
        this.sharedService.openSnackBar(`Grandfather ${id} deleted`, 'Dismiss');
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.sharedService.openErrorDialog(error.businessMessage);
      }
    );
  }

  addDays(date: Date, days: number): Date {
    date.setDate(date.getDate() + days);
    return date;
  }

  chooseDate(endDate: Date, endDateInputFromForm: string): Date {
    return this.endDateDisplay(endDate) == null && endDateInputFromForm !== '' ? this.addDays(new Date(endDateInputFromForm), -1) : this.endDateDisplay(endDate);
  }

  endDateDisplay(testDate: Date): Date {
    if (testDate == null) {
      return null;
    }

    testDate = new Date(testDate);
    const openDate = new Date(this.defaultEndDateValue);
    // eslint-disable-next-line eqeqeq
    return this.isEqualDate(openDate, testDate) ? null : testDate;
  }

  isEqualDate(date1: Date, date2: Date): boolean {
    return date1.setHours(0, 0, 0) == date2.setHours(0, 0, 0);
  }

  therapeuticToString(therapeuticDuplication: TherapeuticDuplicationDTO): string {
    let displayString = '';

    if (therapeuticDuplication.applyTherapeuticDuplication) {
      if (therapeuticDuplication.applyLevelFour) {
        if (therapeuticDuplication.applyLevelFourDosage) {
          displayString += 'Apply level 4 dosage ';
        }
        if (therapeuticDuplication.levelFourDosageIndicator) {
          displayString += 'with rejection; ';
        }
        else {
          displayString += 'with warning; ';
        }
      }

      if (therapeuticDuplication.applyLevelFive) {
        if (therapeuticDuplication.applyLevelFiveDosage) {
          displayString += 'Apply level 5 dosage ';
        }
        if (therapeuticDuplication.levelFiveDosageIndicator) {
          displayString += 'with rejection';
        }
        else {
          displayString += 'with warning';
        }
      }
    }
    else {
      displayString = 'No therapeutic duplication parameters applied';
    }

    return displayString;
  }

  therapeuticDuplicationEnabled(): boolean {
    return this.applyTherapeuticDuplicationFormControl.value;
  }

  levelFourEnabled(): boolean {
    return this.applyLevelFourFormControl.value;
  }

  levelFiveEnabled(): boolean {
    return this.applyLevelFiveFormControl.value;
  }

  changeTherapeuticDuplication() {
    if (this.therapeuticDuplicationEnabled()) {
      this.applyLevelFourFormControl.enable();
      this.applyLevelFiveFormControl.enable();
    }
    else {
      this.applyLevelFourFormControl.setValue(false);
      this.applyLevelFiveFormControl.setValue(false);
      this.applyLevelFourDosageFormControl.setValue(false);
      this.applyLevelFourDosageIndicatorFormControl.setValue(false);
      this.applyLevelFiveDosageFormControl.setValue(false);
      this.applyLevelFiveDosageIndicatorFormControl.setValue(false);

      this.applyLevelFourFormControl.disable();
      this.applyLevelFiveFormControl.disable();
      this.applyLevelFourDosageFormControl.disable();
      this.applyLevelFourDosageIndicatorFormControl.disable();
      this.applyLevelFiveDosageFormControl.disable();
      this.applyLevelFiveDosageIndicatorFormControl.disable();
    }
  }

  changeLevelFour() {
    if (this.levelFourEnabled()) {
      this.applyLevelFourDosageFormControl.enable();
      this.applyLevelFourDosageIndicatorFormControl.enable();
    }
    else {
      this.applyLevelFourDosageFormControl.setValue(false);
      this.applyLevelFourDosageIndicatorFormControl.setValue(false);

      this.applyLevelFourDosageFormControl.disable();
      this.applyLevelFourDosageIndicatorFormControl.disable();
    }
  }

  changeLevelFive() {
    if (this.levelFiveEnabled()) {
      this.applyLevelFiveDosageFormControl.enable();
      this.applyLevelFiveDosageIndicatorFormControl.enable();
    }
    else {
      this.applyLevelFiveDosageFormControl.setValue(false);
      this.applyLevelFiveDosageIndicatorFormControl.setValue(false);

      this.applyLevelFiveDosageFormControl.disable();
      this.applyLevelFiveDosageIndicatorFormControl.disable();
    }
  }

  displayedStepTherapyLinks(): NameDateDTO[] {
    if (this.chosenStepTherapyOption === 'Current') {
      const displayedStepTherapies = this.dmpStepTherapies.filter((stepTherapy) => stepTherapy.startDate !== this.dmpStepTherapies[0].startDate);

      let groupedStepTherapies: NameDateDTO[] = [];
      if (displayedStepTherapies != null && displayedStepTherapies.length > 0) {
        groupedStepTherapies = this.groupStepTherapiesByStartDate(displayedStepTherapies);
      }

      return groupedStepTherapies;
    }
    else {
      const displayedStepTherapies = this.dmpStepTherapies;

      let groupedStepTherapies: NameDateDTO[] = [];
      if (displayedStepTherapies != null && displayedStepTherapies.length > 0) {
        groupedStepTherapies = this.groupStepTherapiesByStartDate(displayedStepTherapies);
      }

      return groupedStepTherapies;
    }
  }

  groupStepTherapiesByStartDate(stepTherapyLinks: StepTherapyManPlanLinkDTO[]): NameDateDTO[] {
    const groupedStepTherapies: NameDateDTO[] = [];

    // Set first start and end date groups
    let startDateGroup = stepTherapyLinks[0].startDate;
    let endDateGroup = stepTherapyLinks[0].endDate;
    let nameString = stepTherapyLinks[0].stepTherapy.name + ', ';

    // Create name - date groups
    for (let i = 1; i < stepTherapyLinks.length; i++) {
      // Check if step therapy is within date group
      // If so,
      if (stepTherapyLinks[i].startDate === startDateGroup) {
        // concat the step therapy names
        nameString = nameString + stepTherapyLinks[i].stepTherapy.name + ', ';
      }
      // If not,
      else {
        // push completed group
        groupedStepTherapies.push({name: nameString, startDate: startDateGroup, endDate: endDateGroup});

        // Set new start and end date groups, and reinisialise nameString
        nameString = stepTherapyLinks[i].stepTherapy.name + ', ';
        startDateGroup = stepTherapyLinks[i].startDate;
        endDateGroup = stepTherapyLinks[i].endDate;
      }
    }
    // Push last group
    groupedStepTherapies.push({name: nameString, startDate: startDateGroup, endDate: endDateGroup});

    return groupedStepTherapies;
  }

  displayedFormularyLinks(): NameDateDTO[] {
    if (this.chosenFormularyOption === 'Current') {
      const displayedFormularyLinks = this.dmpFormularies.filter((formulary) => formulary.startDate !== this.dmpFormularies[0].startDate);

      let groupedFormularies: NameDateDTO[] = [];
      if (displayedFormularyLinks != null && displayedFormularyLinks.length > 0) {
        groupedFormularies = this.groupFormulariesByStartDate(displayedFormularyLinks);
      }

      return groupedFormularies;
    }
    else {
      const displayedFormularyLinks = this.dmpFormularies;

      let groupedFormularies: NameDateDTO[] = [];
      if (displayedFormularyLinks != null && displayedFormularyLinks.length > 0) {
        groupedFormularies = this.groupFormulariesByStartDate(displayedFormularyLinks);
      }

      return groupedFormularies;
    }
  }

  groupFormulariesByStartDate(formularyLinks: NationalDrugFormularyManPlanLinkDTO[]): NameDateDTO[] {
    const groupedFormularies: NameDateDTO[] = [];

    // Set first start and end date groups
    let startDateGroup = formularyLinks[0].startDate;
    let endDateGroup = formularyLinks[0].endDate;
    let nameString = formularyLinks[0].nationalDrugFormulary.name + ', ';

    // Create name - date groups
    for (let i = 1; i < formularyLinks.length; i++) {
      // Check if formulary is within date group
      // If so,
      if (formularyLinks[i].startDate === startDateGroup) {
        // concat the formulary names
        nameString = nameString + formularyLinks[i].nationalDrugFormulary.name + ', ';
      }
      // If not,
      else {
        // push completed group
        groupedFormularies.push({name: nameString, startDate: startDateGroup, endDate: endDateGroup});

        // Set new start and end date groups, and reinisialise nameString
        nameString = formularyLinks[i].nationalDrugFormulary.name + ', ';
        startDateGroup = formularyLinks[i].startDate;
        endDateGroup = formularyLinks[i].endDate;
      }
    }
    // Push last group
    groupedFormularies.push({name: nameString, startDate: startDateGroup, endDate: endDateGroup});

    return groupedFormularies;
  }

  getRefillLink(baseData?: BaseDTO): RefillManPlanLinkDTO {
    const link = new RefillManPlanLinkDTO();

    link.startDate = this.refillStartDateFormControl.value;
    // eslint-disable-next-line eqeqeq
    link.endDate = this.refillEndDateFormControl.value == '' ? new Date(this.defaultEndDateValue) : this.refillEndDateFormControl.value;
    link.refill = this.selectedRefill;

    if (baseData != null) {
      link.created = baseData.created;
      link.createdBy = baseData.createdBy;
      link.tenantId = baseData.tenantId;
    }

    return link;
  }

  getPrescriptionLimit(prescriptionLimitType: number, baseData?: BaseDTO): PrescriptionLimitDTO {
    const link = new PrescriptionLimitDTO();

    link.startDate = this.prescriptionStartDateFormControl.value;
    // eslint-disable-next-line eqeqeq
    link.endDate = this.prescriptionEndDateFormControl.value == '' ? new Date(this.defaultEndDateValue) : this.prescriptionEndDateFormControl.value;
    link.name = `${this.drugManagementPlanNameFormControl.value} ${new Date().getFullYear()}`;

    if (prescriptionLimitType === PrescriptionLimitType.daysDuringpolicy) {
      link.value = this.prescriptionDuringValueFormControl.value;
      link.prescriptionLimitType = this.prescriptionLimitTypes.find(
        (item) => item.value === prescriptionLimitType
      );
    }
    else if (prescriptionLimitType === PrescriptionLimitType.daysPostPolicy) {
      link.value = this.prescriptionAfterValueFormControl.value;
      link.prescriptionLimitType = this.prescriptionLimitTypes.find(
        (item) => item.value === prescriptionLimitType
      );
    }

    if (baseData != null) {
      link.created = baseData.created;
      link.createdBy = baseData.createdBy;
      link.tenantId = baseData.tenantId;
    }

    return link;
  }

  getTherapeuticDuplication(baseData?: BaseDTO): TherapeuticDuplicationDTO {
    const link = new TherapeuticDuplicationDTO();

    link.startDate = this.therapeuticStartDateFormControl.value;
    // eslint-disable-next-line eqeqeq
    link.endDate = this.therapeuticEndDateFormControl.value == '' ? new Date(this.defaultEndDateValue) : this.therapeuticEndDateFormControl.value;
    link.applyTherapeuticDuplication = this.applyTherapeuticDuplicationFormControl.value ? 1 : 0;
    link.applyLevelFour = this.applyLevelFourFormControl.value ? 1 : 0;
    link.applyLevelFourDosage = this.applyLevelFourDosageFormControl.value ? 1 : 0;
    link.levelFourDosageIndicator = this.applyLevelFourDosageIndicatorFormControl.value ? 1 : 0;
    link.applyLevelFive = this.applyLevelFiveFormControl.value ? 1 : 0;
    link.applyLevelFiveDosage = this.applyLevelFiveDosageFormControl.value ? 1 : 0;
    link.levelFiveDosageIndicator = this.applyLevelFiveDosageIndicatorFormControl.value ? 1 : 0;

    if (baseData != null) {
      link.created = baseData.created;
      link.createdBy = baseData.createdBy;
      link.tenantId = baseData.tenantId;
    }

    return link;
  }

  getStepTherapyLink(baseData?: BaseDTO): StepTherapyManPlanLinkDTO[] {
    const stepTherapiesGrpList = this.stepTherapies.controls;
    const stepTherapyLinks: StepTherapyManPlanLinkDTO[] = [];

    const stepTherapyLength = stepTherapiesGrpList.length + (this.stepTherapyFormControl.value === 'none' ? 1 : 0);

    for (let i = 0; i < stepTherapyLength; i++) {
      const link = new StepTherapyManPlanLinkDTO();

      link.startDate = this.stepTherapyStartDateFormControl.value;
      // eslint-disable-next-line eqeqeq
      link.endDate = this.stepTherapyEndDateFormControl.value == '' ? new Date(this.defaultEndDateValue) : this.stepTherapyEndDateFormControl.value;
      // TODO: Ensure this concat works
      const curName = (this.stepTherapyFormControl.value === 'none' ? 'none' : stepTherapiesGrpList[i].value.stepTherapy);
      link.stepTherapy = {
        stepTherapyId: this.displayedStepTherapies.concat(this.removedStepTherapies).find(
          (item) => item.name === curName
        ).value,
        name: curName
      };

      if (baseData != null) {
        link.created = baseData.created;
        link.createdBy = baseData.createdBy;
        link.tenantId = baseData.tenantId;
      }

      stepTherapyLinks.push(link);
    }

    return stepTherapyLinks;
  }

  getFormularyLink(baseData?: BaseDTO): NationalDrugFormularyManPlanLinkDTO[] {
    const formulariesGrpList = this.formularies.controls;
    const formularyLinks: NationalDrugFormularyManPlanLinkDTO[] = [];

    for (let i = 0; i < formulariesGrpList.length; i++) {
      const link = new NationalDrugFormularyManPlanLinkDTO();

      link.startDate = this.formularyStartDateFormControl.value;
      // eslint-disable-next-line eqeqeq
      link.endDate = this.formularyEndDateFormControl.value == '' ? new Date(this.defaultEndDateValue) : this.formularyEndDateFormControl.value;
      link.nationalDrugFormulary = this.filteredFormularies.find(
        (item) => formulariesGrpList[i].value.formulary.includes(item.name)
      );

      if (baseData != null) {
        link.created = baseData.created;
        link.createdBy = baseData.createdBy;
        link.tenantId = baseData.tenantId;
      }

      formularyLinks.push(link);
    }

    return formularyLinks;
  }

  getGrandfatherLink(baseData?: BaseDTO): GrandfatherManPlanLinkDTO {
    const link = new GrandfatherManPlanLinkDTO();

    link.startDate = this.grandfatherStartDateFormControl.value;
    // eslint-disable-next-line eqeqeq
    link.endDate = this.grandfatherEndDateFormControl.value == '' ? new Date(this.defaultEndDateValue) : this.grandfatherEndDateFormControl.value;
    link.grandfather = this.selectedGrandfather;

    if (baseData != null) {
      link.created = baseData.created;
      link.createdBy = baseData.createdBy;
      link.tenantId = baseData.tenantId;
    }

    return link;
  }

  finish() {
    this.isSaving = true;
    const drugManagementPlanDTO = new DrugManagementPlanDTO();

    try {

      const baseData = new BaseDTO();
      if (this.isEdit) {
        drugManagementPlanDTO.drugManagementPlanId = this.editDrugManagementPlan.drugManagementPlanId;
        baseData.updated = new Date();
        baseData.updatedBy = this.userFirstLastName;
        baseData.created = this.editDrugManagementPlan.created;
        baseData.createdBy = this.editDrugManagementPlan.createdBy;
      }
      else {
        baseData.created = new Date();
        baseData.createdBy = this.userFirstLastName;
      }
      drugManagementPlanDTO.name = this.drugManagementPlanNameFormControl.value;
      drugManagementPlanDTO.startDate = this.drugManagementPlanStartDateFormControl.value;
      // eslint-disable-next-line eqeqeq
      drugManagementPlanDTO.endDate = this.getEndDateFromFormValue(this.drugManagementPlanEndDateFormControl);
      if (this.policies != null && this.policies.length > 0) {
        drugManagementPlanDTO.policy = this.policies.find(
          (item) => item.name === this.drugManagementPlanPolicyFormControl.value
        );
      }
      drugManagementPlanDTO.product = this.products.find(
        (item) => item.name === this.drugManagementPlanProductFormControl.value
      );

      if (this.chosenRefillOption === 'New') {
        if (this.isEdit) {
          this.dmpRefills[0].endDate = this.addDays(new Date(this.refillStartDateFormControl.value), -1);
        }
        this.dmpRefills.push(this.getRefillLink(baseData));
      }
      drugManagementPlanDTO.refills = this.dmpRefills;

      if (this.chosenPrescriptionOption === 'New') {
        if (this.isEdit) {
          this.dmpPrescriptions[0].endDate = this.addDays(new Date(this.prescriptionStartDateFormControl.value), -1);
          this.dmpPrescriptions[1].endDate = this.addDays(new Date(this.prescriptionStartDateFormControl.value), -1);
        }
        this.dmpPrescriptions.push(this.getPrescriptionLimit(PrescriptionLimitType.daysDuringpolicy, baseData));
        this.dmpPrescriptions.push(this.getPrescriptionLimit(PrescriptionLimitType.daysPostPolicy, baseData));
      }
      drugManagementPlanDTO.prescriptionLimits = this.dmpPrescriptions;

      if (this.chosenTherapeuticOption === 'New') {
        if (this.isEdit) {
          this.dmpTherapeuticDuplications[0].endDate = this.addDays(new Date(this.therapeuticStartDateFormControl.value), -1);
        }
        this.dmpTherapeuticDuplications.push(this.getTherapeuticDuplication(baseData));
      }
      drugManagementPlanDTO.therapeuticDuplications = this.dmpTherapeuticDuplications;

      if (this.chosenStepTherapyOption === 'New') {
        if (this.isEdit) {
          this.dmpStepTherapies.forEach(stepTherapy => {
            if (stepTherapy.startDate === this.dmpStepTherapies[0].startDate) {
              stepTherapy.endDate = this.addDays(new Date(this.stepTherapyStartDateFormControl.value), -1);
            }
          });
        }
        this.dmpStepTherapies = this.dmpStepTherapies.concat(this.getStepTherapyLink(baseData));
      }
      drugManagementPlanDTO.stepTherapies = this.dmpStepTherapies;

      if (this.chosenFormularyOption === 'New') {
        if (this.isEdit) {
          this.dmpFormularies.forEach(formulary => {
            if (formulary.startDate === this.dmpFormularies[0].startDate) {
              formulary.endDate = this.addDays(new Date(this.formularyStartDateFormControl.value), -1);
            }
          });
        }
        this.dmpFormularies = this.dmpFormularies.concat(this.getFormularyLink(baseData));
      }
      drugManagementPlanDTO.nationalDrugFormularies = this.dmpFormularies;

      if (this.chosenGrandfatherOption === 'New') {
        if (this.isEdit) {
          this.dmpGrandfathers[0].endDate = this.addDays(new Date(this.grandfatherStartDateFormControl.value), -1);
        }
        this.dmpGrandfathers.push(this.getGrandfatherLink(baseData));
      }
      drugManagementPlanDTO.grandfathers = this.dmpGrandfathers;

      drugManagementPlanDTO.created = baseData.created;
      drugManagementPlanDTO.createdBy = baseData.createdBy;
      drugManagementPlanDTO.updated = baseData.updated;
      drugManagementPlanDTO.updatedBy = baseData.updatedBy;
      drugManagementPlanDTO.tenantId = baseData.tenantId;

      this.drugManagementPlanService.saveDrugManagementPlan(drugManagementPlanDTO).subscribe(
        (response) => {
          this.isSaving = false;
          this.sharedService.openSnackBar(
            `Drug management plan ${response.name} saved successfully`,
            'Dismiss'
          );
          this.router.navigate(['/pharmacy-management'], {queryParams: {tab: 'drug-management-plans'}});
        },
        (error) => {
          this.isSaving = false;
          throwError(error);
        }
      );

    } catch (e) {
      this.isSaving = false;
      this.sharedService.openErrorDialog((e as Error).message);
      this.drugManagementPlanStepper.selectedIndex = 0;
    }
  }

  generalStartDateChanged() {
    this.generalStartDate = this.drugManagementPlanStartDateFormControl.value;
    if (this.isEdit) {
      if (this.refillStartDateFormControl.value < this.generalStartDate) {
        this.refillStartDateFormControl.setValue(this.generalStartDate);
      }
      if (this.therapeuticStartDateFormControl.value < this.generalStartDate) {
        this.therapeuticStartDateFormControl.setValue(this.generalStartDate);
      }
      if (this.prescriptionStartDateFormControl.value < this.generalStartDate) {
        this.prescriptionStartDateFormControl.setValue(this.generalStartDate);
      }
      if (this.stepTherapyStartDateFormControl.value < this.generalStartDate) {
        this.stepTherapyStartDateFormControl.setValue(this.generalStartDate);
      }
      if (this.formularyStartDateFormControl.value < this.generalStartDate) {
        this.formularyStartDateFormControl.setValue(this.generalStartDate);
      }
      if (this.grandfatherStartDateFormControl.value < this.generalStartDate) {
        this.grandfatherStartDateFormControl.setValue(this.generalStartDate);
      }
    }
    else {
      this.refillStartDateFormControl.setValue(this.generalStartDate);
      this.therapeuticStartDateFormControl.setValue(this.generalStartDate);
      this.prescriptionStartDateFormControl.setValue(this.generalStartDate);
      this.stepTherapyStartDateFormControl.setValue(this.generalStartDate);
      this.formularyStartDateFormControl.setValue(this.generalStartDate);
      this.grandfatherStartDateFormControl.setValue(this.generalStartDate);
    }
  }

  generalEndDateChanged() {
    this.generalEndDate = this.drugManagementPlanEndDateFormControl.value;
    if (this.isEdit) {
      const formsToUpdate = [];
      formsToUpdate.push(this.addEndDateToUpdateList(this.refillEndDateFormControl, this.generalEndDate));
      formsToUpdate.push(this.addEndDateToUpdateList(this.therapeuticEndDateFormControl, this.generalEndDate));
      formsToUpdate.push(this.addEndDateToUpdateList(this.prescriptionEndDateFormControl, this.generalEndDate));
      formsToUpdate.push(this.addEndDateToUpdateList(this.stepTherapyEndDateFormControl, this.generalEndDate));
      formsToUpdate.push(this.addEndDateToUpdateList(this.formularyEndDateFormControl, this.generalEndDate));
      formsToUpdate.push(this.addEndDateToUpdateList(this.grandfatherEndDateFormControl, this.generalEndDate));

      this.openConfirmationObsrvable('This action will update the current end dates to equal the general end date.\nDo you wish to proceed?')
        .subscribe((isConfirmed) => {
          if (isConfirmed) {
            formsToUpdate.forEach(form => {
              if (form != null) {
                form.setValue(this.generalEndDate);
              }
            });
          }
        });

    }
    else {
      this.refillEndDateFormControl.setValue(this.generalEndDate);
      this.therapeuticEndDateFormControl.setValue(this.generalEndDate);
      this.prescriptionEndDateFormControl.setValue(this.generalEndDate);
      this.stepTherapyEndDateFormControl.setValue(this.generalEndDate);
      this.formularyEndDateFormControl.setValue(this.generalEndDate);
      this.grandfatherEndDateFormControl.setValue(this.generalEndDate);
    }
  }

  getEndDateFromFormValue(endDateForm: FormControl): Date {
    return endDateForm.value === '' || endDateForm.value == null ? new Date(this.defaultEndDateValue) : endDateForm.value;
  }

  getFormValueFromEndDate(endDate: Date): string {
    return this.endDateDisplay(endDate) == null ? '' : this.datePipe.transform(endDate, 'yyyy-MM-dd');
  }

  addEndDateToUpdateList(endDateFormControl: FormControl, endDateToCompare: Date): FormControl {
    let formToUpdate = null;
    if (this.getEndDateFromFormValue(endDateFormControl) > endDateToCompare) {
      formToUpdate = endDateFormControl;
    }
    return formToUpdate;
  }

  openConfirmationObsrvable(message: string): Observable<boolean> {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '40vw',
      data: message
    });

    return dialogRef.afterClosed();
  }

  getRefillDisplayString(refill: RefillDTO): string {
    if (!refill) {
      return '';
    }
    return `${refill?.name} - ${refill.refillValue} ${refill.refillMeasurement.name}`;
  }

  getGrandfatherDisplayString(grandfather: GrandfatherDTO): string {
    if (!grandfather) {
      return '';
    }
    return `${grandfather?.name} - ${grandfather.policy != null ? grandfather.policy?.name : grandfather.insuredPerson?.name}`;
  }

  getFormularyDisplayString(formulary: NationalDrugFormularyDTO): string {
    if (!formulary) {
      return '';
    }
    return `${formulary?.name} - ${formulary.formularyClass?.name}`;
  }

  getMinDate(date1: Date, links: any[]): Date {
    let minDate = (date1 == null ? new Date('1970-01-01') : new Date(date1));
    links.forEach(link => {
      const linkEndDate = new Date(link.endDate);
      const linkStartDate = new Date(link.startDate);
      if (linkEndDate > minDate && !this.isEqualDate(linkEndDate, new Date(this.defaultEndDateValue))) {
        minDate = this.addDays(linkEndDate, 1);
      }
      else if (linkStartDate > minDate) {
        minDate = this.addDays(linkStartDate, 1);
      }
    });
    return minDate;
  }

}
